<template>
    <component :is="component" v-if="localized" v-bind="$props" />
    <div v-else class="d-flex col cards">
        <div v-for="n in 3" :key="n.id" class="card mr-2 text-center">
            {{ n }}
        </div>
    </div>
</template>

<script>
    import LocalizedComponentMixin from "@/components/localization/LocalizedComponentMixin"

    export default {
        name: "DownpaymentSupportedAssociations",
        mixins: [LocalizedComponentMixin],
        data() {
            return {
                componentType: "downpaymentSupportedAssociations",
            }
        },
    }
</script>
